import { ApiParameter, request, ServiceResult } from "@insite/client-framework/Services/ApiService";

export interface OTAParameter {
    attachment?: File;
    registrationdata?: OpenTradeAccountParameter;
}
export interface UpdateOTAParameter extends OTAParameter {
    billToID?: string;
}
export interface OpenTradeAccountParameter extends ApiParameter {
    CompanyInformation?: CompanyInformation | null;
    BusinessOverview?: BusinessOverview | null;
    BillingInformation?: BillingInformation | null;
    website?: string | undefined;
    billToId?: string;
    email?: string;
    step1?: boolean;
    step2?: boolean;
    step3?: boolean;
    step4?: boolean;
    properties?: { [key: string]: string };
}

export interface CompanyInformation {
    CompanyDetails?: CompanyDetails | null;
    PrimaryContact?: PrimaryContact | null;
    // attachment?: any;
    // ackCheckbox?: boolean;
}

export interface CompanyDetails {
    Name?: string;
    Type?: string;
    BusinessLocationState?: string;
    TaxStatus?: string;
    TaxExemptionNo?: string;
    FederalTaxId?: string;
    HDYHAU?: string;
    Specify?: string;
    BusinessLicenseNumber?: string;
    SuryaRepresentativeName?: string;
    VATNumber?: string;
    CompanyRegistrationNumber?: string;
    EoriNumber?: string;
    attachments?: File | any; // dout
    Source: string;
}

export interface PrimaryContact {
    FirstName?: string;
    LastName?: string;
    OrganizationalTitle?: string;
    Phone?: string;
    Email?: string;
    IsSubscribed?: boolean;
}

export interface BusinessOverview {
    Design?: Design;
    Retail?: Retail;
    Ecommerce?: Ecommerce;
    Contract?: Contract;
}

export interface Design {
    Website?: string;
    HMDWAYF?: number;
    WTOODYWOO?: string;
    DYHALOS?: boolean | string;
    OAHMPDYFWOPY?: number;
    ATBPP?: number;
    Segment?: string;
    UrgencyOfFirstOrder?: string;
}
export interface Retail {
    Website?: string;
    HMRLDYH?: number;
    DYOIHDS?: boolean | string;
    WOTFBDYASFAARV?: string;
    WOTFBDYASFLARV?: string;
    Segment?: string;
    UrgencyOfFirstOrder?: string;
    NumberOfSalesAssociates?: number;
    AverageSquareFeetPerLocation?: number;
}
export interface Ecommerce {
    Website?: string;
    IYWINLYPPGLD?: string;
    PLTOHDVYCCOPTC?: string;
    WOTFBDYASFAARV?: string;
    WOTFBDYASFLARV?: string;
}

export interface Contract {
    Website?: string;
    HMDWAYF?: number;
    DYHALOS?: boolean;
    OAHMPDYFWOPY?: number;
    ATBPP?: number;
    DYSPOB?: string;
}

export interface BillingInformation {
    BillingAddress?: BillingAddress;
    AccountsPayable?: AccountsPayable;
}

export interface BillingAddress {
    Name?: string;
    Address1?: string;
    Address2?: string;
    Address3?: string;
    ZipCode?: string;
    City?: string;
    State?: string;
    Country?: string;
    Phone?: string;
    AddressType?: string;
    DockDoorRequired?: string;
    County?: string;
}

export interface AccountsPayable {
    FirstName?: string;
    LastName?: string;
    Email?: string;
}

// export interface NewSubmitData {
//     CompanyInformation: {
//         CompanyDetails: {
//             Name: string | undefined;
//             Type: string | undefined;
//             BusinessLocationState: string | undefined;
//             TaxStatus?: string | undefined;
//             TaxExemptionNo?: string | undefined;
//             FederalTaxId?: string | undefined;
//             HDYHAU?: string | undefined;
//             Specify?: string | undefined;
//         };
//         PrimaryContact: {
//             FirstName?: string | undefined;
//             LastName: string | undefined;
//             OrganizationalTitle: string | undefined;
//             Phone: string | undefined;
//             Email?: string | undefined;
//         };
//     };
//     BusinessOverview: {
//         Design: {
//             Website?: string | undefined;
//             HMDWAYF?: string | undefined;
//             WTOODYWOO?: string | undefined;
//             DYHALOS: string | undefined;
//             OAHMPDYFWOPY: string | undefined;
//             ATBPP: string | undefined;
//         };
//     };
//     BillingInformation: {
//         BillingAddress: {
//             Name: string | undefined;
//             Address1: string | undefined;
//             Address2: string | undefined;
//             Address3: string | undefined;
//             ZipCode: string | undefined;
//             City?: string | undefined;
//             State: string | undefined;
//             Country: string | undefined;
//             Phone: string | undefined;
//         };
//         AccountsPayable: {
//             FirstName: string | undefined;
//             LastName: string | undefined;
//             Email: string | undefined;
//         };
//     };
// }

export interface OpenTradeDataResultModel {}

const OpenTradeAccountUrl = "/api/v2/accountnewcustomer";

export function customOpenTradeAccount(parameter: OTAParameter) {
    const formData = new FormData();
    formData.append("attachment", parameter?.attachment!);
    formData.append("registrationdata[]", JSON.stringify(parameter.registrationdata));
    return request<ServiceResult<OpenTradeDataResultModel>>(OpenTradeAccountUrl, "POST", {}, formData);
}

export function customUpdateOpenTradeAccount(parameter: UpdateOTAParameter) {
    const formData = new FormData();
    formData.append("attachment", parameter?.attachment!);
    formData.append("registrationdata[]", JSON.stringify(parameter.registrationdata));
    return request<ServiceResult<OpenTradeDataResultModel>>(
        `${OpenTradeAccountUrl}/${parameter.billToID}`,
        "PATCH",
        {},
        formData,
    );
}

// // eslint-disable-next-line require-await
// export async function customOpenTradeAccount(parameter: OpenTradeAccountParameter) {
//     const Data: OpenTradeAccountParameter = {
//         CompanyInformation: {
//             CompanyDetails: {
//                 Name: parameter.companyDetails?.companyName,
//                 Type: parameter?.companyDetails?.businessType,
//                 BusinessLocationState: parameter?.companyDetails?.businessLocationState,
//                 TaxStatus: parameter?.companyDetails?.salesTaxStatus,
//                 TaxExemptionNo: parameter?.companyDetails?.taxExemption,
//                 FederalTaxId: parameter?.companyDetails?.taxExemption,
//                 HDYHAU: parameter?.companyDetails?.howDidYouHear,
//                 Specify: parameter?.companyDetails?.specify,
//             },
//             PrimaryContact: {
//                 FirstName: parameter?.companyData?.companyDetails?.primaryContact?.firstName,
//                 LastName: parameter?.companyData?.companyDetails?.primaryContact?.lastName,
//                 OrganizationalTitle: parameter?.companyData?.companyDetails?.primaryContact?.organizationalTitle,
//                 Phone: parameter?.companyData?.companyDetails?.primaryContact?.phone,
//                 Email: parameter?.companyData?.companyDetails?.primaryContact?.email,
//             },
//         },
//         BusinessOverview: {
//             Design: {
//                 Website: parameter?.businessOverview?.website,
//                 HMDWAYF: parameter?.businessOverview?.designers,
//                 WTOODYWOO: parameter?.businessOverview?.typeOfOffice,
//                 DYHALOS: parameter?.businessOverview?.librarianOrStaff,
//                 OAHMPDYFWOPY: parameter?.businessOverview?.avgProjects,
//                 ATBPP: parameter?.businessOverview?.budget,
//             },
//         },
//         BillingInformation: {
//             BillingAddress: {
//                 Name: parameter?.billingInformation?.billingAddress?.billToName,
//                 Address1: parameter?.billingInformation?.billingAddress?.street1,
//                 Address2: parameter?.billingInformation?.billingAddress?.street2,
//                 Address3: parameter?.billingInformation?.billingAddress?.street3,
//                 ZipCode: parameter?.billingInformation?.billingAddress?.zipCode,
//                 City: parameter?.billingInformation?.billingAddress?.city,
//                 State: parameter?.billingInformation?.billingAddress?.state,
//                 Country: parameter?.billingInformation?.billingAddress?.country,
//                 Phone: parameter?.billingInformation?.billingAddress?.phone,
//             },
//             AccountsPayable: {
//                 FirstName: parameter?.billingInformation?.billingAddress?.accountsPayable?.firstName,
//                 LastName: parameter?.billingInformation?.billingAddress?.accountsPayable?.lastName,
//                 Email: parameter?.billingInformation?.billingAddress?.accountsPayable?.email,
//             },
//         },
//     };


//     const formData = new FormData();

//     formData.append("registrationdata", JSON.stringify(Data));

//     return request<ServiceResult<NewSubmitData>>(OpenTradeAccountUrl, "POST", {}, formData);
// }
